import { render, staticRenderFns } from "./ClientPortalEmailTemplateSettings.vue?vue&type=template&id=a6278fb6"
import script from "./ClientPortalEmailTemplateSettings.vue?vue&type=script&lang=ts"
export * from "./ClientPortalEmailTemplateSettings.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a6278fb6')) {
      api.createRecord('a6278fb6', component.options)
    } else {
      api.reload('a6278fb6', component.options)
    }
    module.hot.accept("./ClientPortalEmailTemplateSettings.vue?vue&type=template&id=a6278fb6", function () {
      api.rerender('a6278fb6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/settings-sales/ClientPortalEmailTemplateSettings.vue"
export default component.exports